import i18n from "../../../../../../../constants/i18n";
import Et3Image from "../../../../../../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";

const StripeUserBadge = withLiteObserverAndTheme<{
  wasStripeUser: boolean;
}>((props) => {
  const { wasStripeUser } = props;

  return !wasStripeUser ? null : (
    <Et3Image
      imageName="stripe-logo"
      alt={i18n.get("WAS_STRIPE_USER")}
      size={28}
      type="LOCAL"
      onClick={() => {}}
      style={{ borderRadius: "20%" }}
    />
  );
});
export default StripeUserBadge;
